// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"1507bc09","513":"e0d7d229","703":"62009d17","787":"8c063d36"}[chunkId] + ".chunk.js";
};